const routes = {
  '/app/onboarding': {
    fetch: () =>
      import(
        /* webpackChunkName: 'onboarding-route' */ 'app/onboarding/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
